import { DeleteModal } from '@presentation/components/templates'

type Props = {
  id: string
  onDelete: () => void
}

const DeleteTipoLocalModal: React.FC<Props> = ({ id, onDelete }) => {
  const modalConfigs = {
    id,
    path: '/tipos-local',
    nameForTitle: 'Tipo de Local',
    onDelete
  }

  return <DeleteModal {...modalConfigs} />
}

export default DeleteTipoLocalModal
